import { Grid, Typography } from '@mui/material'
import { isArray } from 'lodash'
import React from 'react'
import { IVideo } from '../hooks/useFetchVideos'
import { VideoCard } from './VideoCard'
import { DotLottleLoader } from '../../../../components/Loader'

export interface VideosContainerProps {
  loading?: boolean
  error?: null | string
  videos: null | IVideo[]
  selectedVideoId: IVideo | number | null
  onSelectVideo: (video: IVideo) => void
  onDeleteVideo?: (i: number) => any
}
export const VideosContainer = ({ videos, loading, error, onDeleteVideo, onSelectVideo, selectedVideoId }: VideosContainerProps) => {  
  if (loading && (!isArray(videos) || videos.length === 0))
    return <DotLottleLoader fill={false} />

  // fetching videos fail
  if (!isArray(videos) && error)
    return (
      <Typography variant="h4" textAlign="center">
        Error while fetching videos
      </Typography>
    )

  // fetching's succeed but nothing to display
  if (isArray(videos) && videos.length === 0)
    return (
      <Typography variant="h4" textAlign="center">
        There&apos;s nothing to display
      </Typography>
    )

    // onDelete={(onDeleteVideo ? (onDeleteVideo(i)) : (false))}

  return (
    <Grid container spacing={2} columns={{ xs: 10 }}>
      {Array.isArray(videos) &&
        videos.map((video: IVideo, i) => (
          <Grid item xs={2} key={i}>
            <VideoCard
              video={video}
              onClick={() => {
                onSelectVideo(video)
              }}
              //@ts-ignore
              onDelete={(onDeleteVideo ? () => {onDeleteVideo(i)} : (false))}
            />
          </Grid>
        ))}
    </Grid>
  )
}

VideosContainer.defaultProps = {
  loading: false,
  error: null,
}
